// extracted by css-extract-rspack-plugin
export default {"copyButton":"Xx17A"};